// ============================================
// DONNÉES CENTRALISÉES - HARMONIE
// Application de gestion d'association musicale
// ============================================

// ---- PRÉFÉRENCES ----
export const preferences = {
  anneeScolaire: '2025-2026',
  debutAnnee: '2025-09-01',
  finAnnee: '2026-06-30',
};

// ---- UTILISATEURS & RÔLES ----
export const roles = [
  { id: 'coordinateur', label: 'Coordinateur', permissions: ['all'] },
  { id: 'tresoriere', label: 'Trésorière', permissions: ['read', 'facturation', 'paiements'] },
  { id: 'professeur', label: 'Professeur', permissions: ['read', 'seances'] },
  { id: 'president', label: 'Président(e)', permissions: ['read'] },
  { id: 'ca_membre', label: 'Membre du CA', permissions: ['read'] },
];

export const users = [
  { id: 'u1', nom: 'Admin', prenom: 'Système', email: 'admin@harmonie.fr', role: 'coordinateur', initials: 'AD', color: '#8B5CF6' },
  { id: 'u2', nom: 'Blanc', prenom: 'Catherine', email: 'c.blanc@harmonie.fr', role: 'tresoriere', initials: 'CB', color: '#EC4899' },
  { id: 'u3', nom: 'Dupont', prenom: 'Marie', email: 'm.dupont@harmonie.fr', role: 'professeur', initials: 'MD', color: '#10B981' },
  { id: 'u4', nom: 'Martin', prenom: 'Jean-Pierre', email: 'jp.martin@harmonie.fr', role: 'professeur', initials: 'JM', color: '#F59E0B' },
  { id: 'u5', nom: 'Duval', prenom: 'Robert', email: 'r.duval@harmonie.fr', role: 'president', initials: 'RD', color: '#3B82F6' },
  { id: 'u6', nom: 'Mercier', prenom: 'Anne', email: 'a.mercier@harmonie.fr', role: 'ca_membre', initials: 'AM', color: '#6366F1' },
];

export const defaultCredentials = [
  { login: 'admin', password: 'admin', userId: 'u1' },
  { login: 'tresoriere', password: 'tresoriere', userId: 'u2' },
  { login: 'prof', password: 'prof', userId: 'u3' },
  { login: 'president', password: 'president', userId: 'u5' },
];

// ---- PROFESSEURS ----
export const professeurs = [
  { id: 'p1', nom: 'Dupont', prenom: 'Marie', specialites: ['Piano'], email: 'm.dupont@harmonie.fr', telephone: '06 12 34 56 78', initials: 'MD', color: '#10B981' },
  { id: 'p2', nom: 'Martin', prenom: 'Jean-Pierre', specialites: ['Guitare'], email: 'jp.martin@harmonie.fr', telephone: '06 23 45 67 89', initials: 'JM', color: '#F59E0B' },
  { id: 'p3', nom: 'Laurent', prenom: 'Sophie', specialites: ['Violon', 'Alto'], email: 's.laurent@harmonie.fr', telephone: '06 34 56 78 90', initials: 'SL', color: '#EC4899' },
  { id: 'p4', nom: 'Bernard', prenom: 'François', specialites: ['Saxophone', 'Clarinette'], email: 'f.bernard@harmonie.fr', telephone: '06 45 67 89 01', initials: 'FB', color: '#8B5CF6' },
  { id: 'p5', nom: 'Petit', prenom: 'Isabelle', specialites: ['Chant', 'Chorale', 'FM'], email: 'i.petit@harmonie.fr', telephone: '06 56 78 90 12', initials: 'IP', color: '#6366F1' },
  { id: 'p6', nom: 'Roux', prenom: 'Nicolas', specialites: ['Batterie', 'Percussions'], email: 'n.roux@harmonie.fr', telephone: '06 67 89 01 23', initials: 'NR', color: '#EF4444' },
];

// ---- PRODUITS ----
// Deux catégories : 'cours' (cours de musique) et 'instrument' (lié à des cours)
export const produits = [
  // --- Cours de musique ---
  { id: 'prod1', nom: 'Piano - Cours individuel', categorie: 'cours', description: 'Cours individuel de piano, 30 min/semaine', tarif: 450, duree: 30, frequence: ['Lundi', 'Mercredi'], professeurId: 'p1', salle: 'Salle 1' },
  { id: 'prod2', nom: 'Guitare - Cours individuel', categorie: 'cours', description: 'Cours individuel de guitare, 30 min/semaine', tarif: 450, duree: 30, frequence: ['Mardi', 'Jeudi'], professeurId: 'p2', salle: 'Salle 2' },
  { id: 'prod3', nom: 'Violon - Cours individuel', categorie: 'cours', description: 'Cours individuel de violon, 30 min/semaine', tarif: 450, duree: 30, frequence: ['Lundi', 'Mercredi'], professeurId: 'p3', salle: 'Salle 3' },
  { id: 'prod4', nom: 'Saxophone - Cours individuel', categorie: 'cours', description: 'Cours individuel de saxophone, 30 min/semaine', tarif: 450, duree: 30, frequence: ['Mardi'], professeurId: 'p4', salle: 'Salle 4' },
  { id: 'prod5', nom: 'Batterie - Cours individuel', categorie: 'cours', description: 'Cours individuel de batterie, 30 min/semaine', tarif: 450, duree: 30, frequence: ['Mercredi', 'Vendredi'], professeurId: 'p6', salle: 'Salle 5' },
  { id: 'prod6', nom: 'Éveil musical', categorie: 'cours', description: 'Cours collectif d\'éveil musical, 45 min/semaine', tarif: 180, duree: 45, frequence: ['Mercredi'], professeurId: 'p5', salle: 'Grande salle' },
  { id: 'prod7', nom: 'Formation Musicale', categorie: 'cours', description: 'Cours collectif de formation musicale, 1h/semaine', tarif: 120, duree: 60, frequence: ['Mercredi'], professeurId: 'p5', salle: 'Grande salle' },
  { id: 'prod8', nom: 'Chorale', categorie: 'cours', description: 'Chorale, 1h/semaine', tarif: 80, duree: 60, frequence: ['Samedi'], professeurId: 'p5', salle: 'Grande salle' },
  { id: 'prod9', nom: 'Ensemble instrumental', categorie: 'cours', description: 'Pratique d\'ensemble, 1h/semaine', tarif: 60, duree: 60, frequence: ['Samedi'], professeurId: 'p4', salle: 'Grande salle' },

  // --- Instruments (liés à des cours) ---
  { id: 'prod10', nom: 'Location Violon', categorie: 'instrument', description: 'Location annuelle d\'un violon (taille adaptée)', tarif: 150, coursAssocies: ['prod3'] },
  { id: 'prod11', nom: 'Location Saxophone', categorie: 'instrument', description: 'Location annuelle d\'un saxophone alto', tarif: 150, coursAssocies: ['prod4'] },
  { id: 'prod12', nom: 'Location Guitare', categorie: 'instrument', description: 'Location annuelle d\'une guitare classique', tarif: 120, coursAssocies: ['prod2'] },
  { id: 'prod13', nom: 'Location Clarinette', categorie: 'instrument', description: 'Location annuelle d\'une clarinette Sib', tarif: 150, coursAssocies: ['prod4'] },
  { id: 'prod14', nom: 'Location Flûte traversière', categorie: 'instrument', description: 'Location annuelle d\'une flûte traversière', tarif: 130, coursAssocies: [] },

  // --- Autre ---
  { id: 'prod15', nom: 'Adhésion annuelle', categorie: 'autre', description: 'Cotisation associative obligatoire', tarif: 25, obligatoire: true },
];

// ---- INSCRIPTIONS ----
// statut : 'en_attente' | 'validee' | 'facturee'
export const inscriptions = [
  {
    id: 'ins1', statut: 'facturee', dateInscription: '2025-09-01',
    eleve: { nom: 'Moreau', prenom: 'Lucas', dateNaissance: '2012-03-15', adresse: '12 rue des Lilas, 75012 Paris', telephone: '06 11 22 33 44', email: 'lucas.moreau@email.fr' },
    responsable: { nom: 'Moreau', prenom: 'Stéphanie', lien: 'Mère', telephone: '06 11 22 33 44', email: 'stephanie.moreau@email.fr' },
    produitsIds: ['prod15', 'prod1', 'prod7'],
    rgpdConsent: true, echelonnement: 3, notes: '',
    initials: 'LM', color: '#8B5CF6',
  },
  {
    id: 'ins2', statut: 'facturee', dateInscription: '2025-09-01',
    eleve: { nom: 'Moreau', prenom: 'Emma', dateNaissance: '2015-07-22', adresse: '12 rue des Lilas, 75012 Paris', telephone: '06 11 22 33 44', email: 'emma.moreau@email.fr' },
    responsable: { nom: 'Moreau', prenom: 'Stéphanie', lien: 'Mère', telephone: '06 11 22 33 44', email: 'stephanie.moreau@email.fr' },
    produitsIds: ['prod15', 'prod3', 'prod7', 'prod10'],
    rgpdConsent: true, echelonnement: 3, notes: '',
    initials: 'EM', color: '#EC4899',
  },
  {
    id: 'ins3', statut: 'facturee', dateInscription: '2025-09-02',
    eleve: { nom: 'Dubois', prenom: 'Hugo', dateNaissance: '2010-11-08', adresse: '45 avenue Victor Hugo, 75016 Paris', telephone: '06 22 33 44 55', email: 'hugo.dubois@email.fr' },
    responsable: { nom: 'Dubois', prenom: 'Pierre', lien: 'Père', telephone: '06 22 33 44 55', email: 'pierre.dubois@email.fr' },
    produitsIds: ['prod15', 'prod2', 'prod5', 'prod7'],
    rgpdConsent: true, echelonnement: 3, notes: '',
    initials: 'HD', color: '#10B981',
  },
  {
    id: 'ins4', statut: 'facturee', dateInscription: '2025-09-01',
    eleve: { nom: 'Lambert', prenom: 'Léa', dateNaissance: '2013-01-30', adresse: '8 place de la Mairie, 75005 Paris', telephone: '06 33 44 55 66', email: 'lea.lambert@email.fr' },
    responsable: { nom: 'Lambert', prenom: 'Nathalie', lien: 'Mère', telephone: '06 33 44 55 66', email: 'nathalie.lambert@email.fr' },
    produitsIds: ['prod15', 'prod1', 'prod7'],
    rgpdConsent: true, echelonnement: 1, notes: '',
    initials: 'LL', color: '#F59E0B',
  },
  {
    id: 'ins5', statut: 'validee', dateInscription: '2025-09-03',
    eleve: { nom: 'Lambert', prenom: 'Nathan', dateNaissance: '2016-05-12', adresse: '8 place de la Mairie, 75005 Paris', telephone: '06 33 44 55 66', email: 'nathan.lambert@email.fr' },
    responsable: { nom: 'Lambert', prenom: 'Nathalie', lien: 'Mère', telephone: '06 33 44 55 66', email: 'nathalie.lambert@email.fr' },
    produitsIds: ['prod15', 'prod3', 'prod10', 'prod7'],
    rgpdConsent: true, echelonnement: 2, notes: '',
    initials: 'NL', color: '#3B82F6',
  },
  {
    id: 'ins6', statut: 'validee', dateInscription: '2025-09-04',
    eleve: { nom: 'Lambert', prenom: 'Chloé', dateNaissance: '2009-09-18', adresse: '8 place de la Mairie, 75005 Paris', telephone: '06 33 44 55 66', email: 'chloe.lambert@email.fr' },
    responsable: { nom: 'Lambert', prenom: 'Nathalie', lien: 'Mère', telephone: '06 33 44 55 66', email: 'nathalie.lambert@email.fr' },
    produitsIds: ['prod15', 'prod4', 'prod11', 'prod7', 'prod8'],
    rgpdConsent: true, echelonnement: 4, notes: '',
    initials: 'CL', color: '#6366F1',
  },
  {
    id: 'ins7', statut: 'en_attente', dateInscription: '2025-09-10',
    eleve: { nom: 'Garcia', prenom: 'Sofia', dateNaissance: '2014-12-03', adresse: '23 boulevard Haussmann, 75009 Paris', telephone: '06 44 55 66 77', email: 'sofia.garcia@email.fr' },
    responsable: { nom: 'Garcia', prenom: 'Carmen', lien: 'Mère', telephone: '06 44 55 66 77', email: 'carmen.garcia@email.fr' },
    produitsIds: ['prod15', 'prod1', 'prod7'],
    rgpdConsent: true, echelonnement: 1, notes: '',
    initials: 'SG', color: '#EF4444',
  },
  {
    id: 'ins8', statut: 'en_attente', dateInscription: '2025-09-12',
    eleve: { nom: 'Lefebvre', prenom: 'Jules', dateNaissance: '2011-06-25', adresse: '56 rue du Faubourg, 75011 Paris', telephone: '06 55 66 77 88', email: 'jules.lefebvre@email.fr' },
    responsable: { nom: 'Lefebvre', prenom: 'Marc', lien: 'Père', telephone: '06 55 66 77 88', email: 'marc.lefebvre@email.fr' },
    produitsIds: ['prod15', 'prod2', 'prod12', 'prod7'],
    rgpdConsent: true, echelonnement: 2, notes: '',
    initials: 'JL', color: '#8B5CF6',
  },
  {
    id: 'ins9', statut: 'facturee', dateInscription: '2025-09-01',
    eleve: { nom: 'Lefebvre', prenom: 'Manon', dateNaissance: '2017-04-14', adresse: '56 rue du Faubourg, 75011 Paris', telephone: '06 55 66 77 88', email: 'manon.lefebvre@email.fr' },
    responsable: { nom: 'Lefebvre', prenom: 'Marc', lien: 'Père', telephone: '06 55 66 77 88', email: 'marc.lefebvre@email.fr' },
    produitsIds: ['prod15', 'prod6'],
    rgpdConsent: true, echelonnement: 1, notes: '',
    initials: 'ML', color: '#EC4899',
  },
  {
    id: 'ins10', statut: 'facturee', dateInscription: '2025-09-02',
    eleve: { nom: 'Thomas', prenom: 'Théo', dateNaissance: '2008-08-07', adresse: '3 impasse des Roses, 75014 Paris', telephone: '06 66 77 88 99', email: 'theo.thomas@email.fr' },
    responsable: { nom: 'Thomas', prenom: 'Véronique', lien: 'Mère', telephone: '06 66 77 88 99', email: 'veronique.thomas@email.fr' },
    produitsIds: ['prod15', 'prod5', 'prod7', 'prod8'],
    rgpdConsent: true, echelonnement: 3, notes: '',
    initials: 'TT', color: '#10B981',
  },
];

// ---- SÉANCES ----
// Générées à partir des cours et de leur fréquence
// statut: 'planifiee' | 'effectuee' | 'annulee'
export const seances = [
  { id: 'sea1', produitId: 'prod1', date: '2025-09-01', heureDebut: '14:00', heureFin: '14:30', statut: 'effectuee', inscriptionsPresentes: ['ins1', 'ins4'] },
  { id: 'sea2', produitId: 'prod1', date: '2025-09-03', heureDebut: '14:00', heureFin: '14:30', statut: 'effectuee', inscriptionsPresentes: ['ins1'] },
  { id: 'sea3', produitId: 'prod1', date: '2025-09-08', heureDebut: '14:00', heureFin: '14:30', statut: 'effectuee', inscriptionsPresentes: ['ins1', 'ins4'] },
  { id: 'sea4', produitId: 'prod2', date: '2025-09-02', heureDebut: '14:00', heureFin: '14:30', statut: 'effectuee', inscriptionsPresentes: ['ins3'] },
  { id: 'sea5', produitId: 'prod2', date: '2025-09-04', heureDebut: '14:00', heureFin: '14:30', statut: 'effectuee', inscriptionsPresentes: ['ins3'] },
  { id: 'sea6', produitId: 'prod3', date: '2025-09-01', heureDebut: '14:00', heureFin: '14:30', statut: 'effectuee', inscriptionsPresentes: ['ins2'] },
  { id: 'sea7', produitId: 'prod3', date: '2025-09-03', heureDebut: '14:00', heureFin: '14:30', statut: 'effectuee', inscriptionsPresentes: ['ins2'] },
  { id: 'sea8', produitId: 'prod5', date: '2025-09-03', heureDebut: '14:00', heureFin: '14:30', statut: 'effectuee', inscriptionsPresentes: ['ins3', 'ins10'] },
  { id: 'sea9', produitId: 'prod7', date: '2025-09-03', heureDebut: '15:00', heureFin: '16:00', statut: 'effectuee', inscriptionsPresentes: ['ins1', 'ins2', 'ins3', 'ins4', 'ins10'] },
  { id: 'sea10', produitId: 'prod8', date: '2025-09-06', heureDebut: '10:00', heureFin: '11:00', statut: 'effectuee', inscriptionsPresentes: ['ins10'] },
  { id: 'sea11', produitId: 'prod6', date: '2025-09-03', heureDebut: '10:00', heureFin: '10:45', statut: 'effectuee', inscriptionsPresentes: ['ins9'] },
  { id: 'sea12', produitId: 'prod1', date: '2025-09-15', heureDebut: '14:00', heureFin: '14:30', statut: 'planifiee', inscriptionsPresentes: [] },
  { id: 'sea13', produitId: 'prod2', date: '2025-09-16', heureDebut: '14:00', heureFin: '14:30', statut: 'planifiee', inscriptionsPresentes: [] },
  { id: 'sea14', produitId: 'prod7', date: '2025-09-10', heureDebut: '15:00', heureFin: '16:00', statut: 'planifiee', inscriptionsPresentes: [] },
];

// ---- FACTURES ----
// Générées depuis les inscriptions validées
export const factures = [
  {
    id: 'fac1', numero: 'FAC-2025-001', inscriptionId: 'ins1', date: '2025-09-15', echeance: '2025-10-15',
    lignes: [
      { produitId: 'prod15', label: 'Adhésion annuelle', montant: 25 },
      { produitId: 'prod1', label: 'Piano - Cours individuel', montant: 450 },
      { produitId: 'prod7', label: 'Formation Musicale', montant: 120 },
    ],
    totalNet: 595, statut: 'payee',
  },
  {
    id: 'fac2', numero: 'FAC-2025-002', inscriptionId: 'ins2', date: '2025-09-15', echeance: '2025-10-15',
    lignes: [
      { produitId: 'prod15', label: 'Adhésion annuelle', montant: 25 },
      { produitId: 'prod3', label: 'Violon - Cours individuel', montant: 450 },
      { produitId: 'prod7', label: 'Formation Musicale', montant: 120 },
      { produitId: 'prod10', label: 'Location Violon', montant: 150 },
    ],
    totalNet: 745, statut: 'payee',
  },
  {
    id: 'fac3', numero: 'FAC-2025-003', inscriptionId: 'ins3', date: '2025-09-15', echeance: '2025-10-15',
    lignes: [
      { produitId: 'prod15', label: 'Adhésion annuelle', montant: 25 },
      { produitId: 'prod2', label: 'Guitare - Cours individuel', montant: 450 },
      { produitId: 'prod5', label: 'Batterie - Cours individuel', montant: 450 },
      { produitId: 'prod7', label: 'Formation Musicale', montant: 120 },
    ],
    totalNet: 1045, statut: 'partielle',
  },
  {
    id: 'fac4', numero: 'FAC-2025-004', inscriptionId: 'ins4', date: '2025-09-15', echeance: '2025-10-15',
    lignes: [
      { produitId: 'prod15', label: 'Adhésion annuelle', montant: 25 },
      { produitId: 'prod1', label: 'Piano - Cours individuel', montant: 450 },
      { produitId: 'prod7', label: 'Formation Musicale', montant: 120 },
    ],
    totalNet: 595, statut: 'impayee',
  },
  {
    id: 'fac5', numero: 'FAC-2025-005', inscriptionId: 'ins9', date: '2025-09-18', echeance: '2025-10-18',
    lignes: [
      { produitId: 'prod15', label: 'Adhésion annuelle', montant: 25 },
      { produitId: 'prod6', label: 'Éveil musical', montant: 180 },
    ],
    totalNet: 205, statut: 'payee',
  },
  {
    id: 'fac6', numero: 'FAC-2025-006', inscriptionId: 'ins10', date: '2025-09-18', echeance: '2025-10-18',
    lignes: [
      { produitId: 'prod15', label: 'Adhésion annuelle', montant: 25 },
      { produitId: 'prod5', label: 'Batterie - Cours individuel', montant: 450 },
      { produitId: 'prod7', label: 'Formation Musicale', montant: 120 },
      { produitId: 'prod8', label: 'Chorale', montant: 80 },
    ],
    totalNet: 675, statut: 'payee',
  },
];

// ---- PAIEMENTS ----
export const paiements = [
  { id: 'pay1', factureId: 'fac1', date: '2025-09-20', montant: 198.33, mode: 'Prélèvement', reference: 'PREL-001' },
  { id: 'pay2', factureId: 'fac1', date: '2025-11-15', montant: 198.33, mode: 'Prélèvement', reference: 'PREL-002' },
  { id: 'pay3', factureId: 'fac1', date: '2026-01-15', montant: 198.34, mode: 'Prélèvement', reference: 'PREL-003' },
  { id: 'pay4', factureId: 'fac2', date: '2025-09-20', montant: 248.33, mode: 'Chèque', reference: 'CHQ-101' },
  { id: 'pay5', factureId: 'fac2', date: '2025-11-15', montant: 248.33, mode: 'Chèque', reference: 'CHQ-102' },
  { id: 'pay6', factureId: 'fac2', date: '2026-01-15', montant: 248.34, mode: 'Chèque', reference: 'CHQ-103' },
  { id: 'pay7', factureId: 'fac3', date: '2025-09-20', montant: 348.33, mode: 'Prélèvement', reference: 'PREL-010' },
  { id: 'pay8', factureId: 'fac3', date: '2025-12-15', montant: 348.33, mode: 'Prélèvement', reference: 'PREL-011' },
  { id: 'pay9', factureId: 'fac5', date: '2025-09-25', montant: 205, mode: 'CB', reference: 'CB-001' },
  { id: 'pay10', factureId: 'fac6', date: '2025-09-25', montant: 225, mode: 'Virement', reference: 'VIR-001' },
  { id: 'pay11', factureId: 'fac6', date: '2025-12-15', montant: 225, mode: 'Virement', reference: 'VIR-002' },
  { id: 'pay12', factureId: 'fac6', date: '2026-03-15', montant: 225, mode: 'Virement', reference: 'VIR-003' },
];

// ---- RELANCES ----
export const relances = [
  { id: 'rel1', factureId: 'fac4', date: '2025-10-25', type: 'email', message: 'Première relance — Facture FAC-2025-004 impayée', statut: 'envoyee' },
  { id: 'rel2', factureId: 'fac4', date: '2025-11-15', type: 'courrier', message: 'Deuxième relance — Facture FAC-2025-004 impayée', statut: 'envoyee' },
  { id: 'rel3', factureId: 'fac3', date: '2026-02-01', type: 'email', message: 'Rappel — 3ème échéance facture FAC-2025-003', statut: 'envoyee' },
];

// ---- HELPERS ----
export const getProduit = (id) => produits.find(p => p.id === id);
export const getProfesseur = (id) => professeurs.find(p => p.id === id);
export const getInscription = (id) => inscriptions.find(i => i.id === id);
export const getFactureByInscription = (inscriptionId) => factures.find(f => f.inscriptionId === inscriptionId);
export const getPaiementsByFacture = (factureId) => paiements.filter(p => p.factureId === factureId);
export const getSeancesByProduit = (produitId) => seances.filter(s => s.produitId === produitId);
export const getCoursProduits = () => produits.filter(p => p.categorie === 'cours');
export const getInstrumentProduits = () => produits.filter(p => p.categorie === 'instrument');
export const getInstrumentsForCours = (coursId) => produits.filter(p => p.categorie === 'instrument' && p.coursAssocies && p.coursAssocies.includes(coursId));

export const calculerAge = (dateNaissance) => {
  const today = new Date();
  const birth = new Date(dateNaissance);
  let age = today.getFullYear() - birth.getFullYear();
  const m = today.getMonth() - birth.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) age--;
  return age;
};

export const calculerTotalInscription = (inscription) => {
  return inscription.produitsIds.reduce((sum, pid) => {
    const p = getProduit(pid);
    return sum + (p ? p.tarif : 0);
  }, 0);
};

export const formatMontant = (montant) => {
  return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(montant);
};

export const formatDate = (dateStr) => {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  return d.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' });
};

export const JOURS_SEMAINE = ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche'];

export const genererSeancesPourCours = (produit, debutStr, finStr) => {
  const jourIndex = { 'Lundi': 1, 'Mardi': 2, 'Mercredi': 3, 'Jeudi': 4, 'Vendredi': 5, 'Samedi': 6, 'Dimanche': 0 };
  const debut = new Date(debutStr);
  const fin = new Date(finStr);
  const result = [];
  if (!produit.frequence) return result;

  for (const jour of produit.frequence) {
    const targetDay = jourIndex[jour];
    const current = new Date(debut);
    const diff = (targetDay - current.getDay() + 7) % 7;
    current.setDate(current.getDate() + diff);

    while (current <= fin) {
      const dureeMin = produit.duree || 30;
      const hDebut = '14:00';
      const hMin = parseInt(hDebut.split(':')[1]) + dureeMin;
      const hFin = `${Math.floor(14 + hMin / 60)}:${String(hMin % 60).padStart(2, '0')}`;
      result.push({
        id: `gen-${produit.id}-${current.toISOString().split('T')[0]}`,
        produitId: produit.id,
        date: current.toISOString().split('T')[0],
        heureDebut: hDebut,
        heureFin: hFin,
        statut: 'planifiee',
        inscriptionsPresentes: [],
      });
      current.setDate(current.getDate() + 7);
    }
  }
  return result.sort((a, b) => a.date.localeCompare(b.date));
};
